export * from '@fhs/routing/src/routes/v2/cart/(checkout)/index';
export { default } from '@fhs/routing/src/routes/v2/cart/(checkout)/index';
